<template>
    <v-sheet class="d-flex flex-column align-center">
        <v-icon
            :color="feedback_color"
            class="my-8"
            size="72"
        >
            {{ feedback_icon }}
        </v-icon>
        <div class="text-h6 bold text-center px-4">{{ title }}</div>

        <div style="max-width: 400px">
            <div class="text-body-1 pa-4">
                {{ text }}
            </div>
        </div>
        <v-spacer />
        <v-btn
            @click="$emit('close')"
            class="mb-12"
            variant="outlined"
        >
            {{ translate('common.return_to_debts') }}
        </v-btn>
    </v-sheet>
</template>

<script>
import { locales_mixin } from '@old/mixins/locales_mixin'
import { mapActions, mapState } from 'vuex'
import { date_mixin } from '@old/mixins/date_mixin'
import { utils_mixin } from '@old/mixins/utils_mixin'

export default {
    name: 'RespiteFeedback',
    props: {
        feedback: {
            type: String,
        },
    },
    mixins: [date_mixin, locales_mixin, utils_mixin],
    components: {},
    emits: ['close'],
    data() {
        return {}
    },
    computed: {
        feedback_icon() {
            switch (this.feedback) {
                case 'success':
                    return 'mdi-checkbox-marked-circle-outline'
                case 'failed':
                    return 'mdi-alert-octagon-outline'
                default:
                    return null
            }
        },
        feedback_color() {
            switch (this.feedback) {
                case 'success':
                    return 'success'
                case 'failed':
                    return 'error'
                default:
                    return null
            }
        },
        title() {
            return this.translate(`common.respite_${this.feedback}_title`)
        },
        schedule_to_execute() {
            return this.format_date(this.deep_get(this.respite, 'document.next_flow_item.schedule_to_execute'))
        },
        text() {
            return this.translate(`common.respite_${this.feedback}_text`, [this.schedule_to_execute] )
        },
        ...mapState(['respite']),
    },
    watch: {},
    methods: {
        ...mapActions(['update_key_in_state_property']),
    },
    beforeCreate() {
    },
    created() {
    },
    beforeMount() {
    },
    mounted() {
    },
    beforeUpdate() {
    },
    updated() {
    },
    beforeUnmount() {
    },
}
</script>

<style scoped lang="sass"></style>
